import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	text: {
		id: 'backlog.card-list.card.card-contents.versions-field.text',
		defaultMessage: '{count} versions',
		description:
			'Text displayed inside version lozenge when card has multiple versions. Displayed on Jira card in the backlog',
	},
	ariaLabel: {
		id: 'backlog.card-list.card.card-contents.versions-field.aria-label',
		defaultMessage: '{versions} {count, plural, one {version} other {versions}}',
		description:
			'Accessibility text displayed for version lozenge displayed on Jira card on backlog',
	},
});
